export default {"src":"/_next/static/media/SubDesc1.4bb3dfff.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};